import { useI18n } from "@/lib/i18n";

export function PageHeader({ overline, title, subtitle, actions, testid }) {
  return (
    <div
      data-testid={testid || "page-header"}
      className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between border-b border-border pb-5 mb-6"
    >
      <div>
        {overline && <p className="overline mb-2">{overline}</p>}
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tight leading-[1.05]">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-2 text-sm text-muted-foreground max-w-2xl">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ title, hint, action }) {
  return (
    <div
      data-testid="empty-state"
      className="border border-dashed border-border rounded-md py-14 px-6 text-center bg-white"
    >
      <p className="font-display font-semibold text-lg">{title}</p>
      {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}

export function StatusBadge({ value }) {
  const map = {
    pending: { bg: "bg-amber-50", text: "text-amber-700", ring: "ring-amber-200", label_key: "status_pending" },
    in_transit: { bg: "bg-slate-100", text: "text-slate-800", ring: "ring-slate-200", label_key: "status_in_transit" },
    delivered: { bg: "bg-emerald-50", text: "text-emerald-700", ring: "ring-emerald-200", label_key: "status_delivered" },
    cancelled: { bg: "bg-red-50", text: "text-red-700", ring: "ring-red-200", label_key: "status_cancelled" },
    draft: { bg: "bg-slate-100", text: "text-slate-700", ring: "ring-slate-200", label_key: "order_status_draft" },
    confirmed: { bg: "bg-amber-50", text: "text-amber-800", ring: "ring-amber-200", label_key: "order_status_confirmed" },
    converted: { bg: "bg-amber-50", text: "text-amber-800", ring: "ring-amber-200", label_key: "order_status_converted" },
  };
  const cfg = map[value] || map.pending;
  const { t } = useI18n();
  return (
    <span
      data-testid={`status-badge-${value}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-xs font-medium ring-1 ring-inset ${cfg.bg} ${cfg.text} ${cfg.ring}`}
    >
      <span className={`inline-block size-1.5 rounded-full ${cfg.text} bg-current dot-pulse`}></span>
      {t(cfg.label_key)}
    </span>
  );
}
